import PassengerBreakdown from "../PassengerBreakdown/PassengerBreakdown";
import SSRBreakdown from "../SSRBreakdown/SSRBreakdown";
import TotalAmount from "../TotalAmount/TotalAmount";
import TotalTopCard from "../TotalTopCard/TotalTopCard";

export default function TripMoneyBreakdown() {
  return (
    <div className="bg-background-default flex flex-col gap-3 rounded-xl p-5 shadow-sm">
      <div>
        <TotalTopCard />
      </div>
      <div>
        <PassengerBreakdown />
      </div>
      <div>
        <SSRBreakdown />
      </div>
      <div className="border-border-subtle w-full border-t border-dashed" />
      <div>
        <TotalAmount />
      </div>
    </div>
  );
}
